import React from "react";

import { notification } from "antd";

import styles from "./Thumb.module.less";

import { CloudUploadOutlined, EyeFilled, EditFilled } from "@ant-design/icons";

function Thumb(value) {
  const onThumbSee = () => {
    notification.open({
      message: "图片查看",
      description: (
        <img className={styles.showThumb} alt="" src={value.value} />
      ),
      style: {
        width: 400,
        marginLeft: -15,
      },
      duration: 5,
    });
  };
  return (
    <div className={styles.Thumb}>
      {value.multiple ? (
        <div className={styles.multiple}>
          {value?.value
            ? value.value.map((val) => (
                <div className={styles.picture}>
                  <img src={val} alt="" />
                  <div className={styles.handle}>
                    <EyeFilled onClick={() => onThumbSee()} />
                  </div>
                </div>
              ))
            : null}
          <div className={styles.upload} onClick={value.onClick}>
            <CloudUploadOutlined style={{ color: "#cccccc", fontSize: 36 }} />
            <i>{value.title}</i>
          </div>
        </div>
      ) : (
        <div className={styles.single}>
          {value.value ? (
            <div className={styles.picture}>
              <img src={value.value} alt="" />
              <div className={styles.handle}>
                <EyeFilled onClick={() => onThumbSee()} />
                <EditFilled onClick={value.onClick} />
              </div>
            </div>
          ) : (
            <div className={styles.upload} onClick={value.onClick}>
              <CloudUploadOutlined style={{ color: "#cccccc", fontSize: 36 }} />
              <i>{value.title}</i>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Thumb;
